
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    SortBox: () => import("@/components/SortBox.vue"),
    ExportButton: () => import("@/components/ExportButton.vue")
  }
})
export default class CompaniesIndex extends Vue {
  exportApiUrl: string = "companies/exportxls";
  companies: any = [];
  business: any = [];
  limit: number = 5;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: "Empresa",
    owner: "Responsable",
    deletedAt: "Estado"
  };
  currentSort: Record<string, string> = {
    col: "name",
    dir: "asc"
  };
  filter: any = {
    businessId: null,
    // controlZoneId: "",
    // month: "",
    // year: "",
    // reporttype: "",
    // branchId: "",
    // trimester: "",
    // status_client: "",
    // status_admin: "",
    // code: "",
    // requestNumber: "",
    // seguredName: "",
    // claimCode: "",
    // claimNumber: "",
    // modifyType: -1
  };

  async mounted() {
    this.loadCompanies(1, this.currentSort);
    await this.loadBusiness();
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadCompanies(page, this.currentSort);
  }
  
  async exportXLS() {
    try {
      const response: any = await (this.$root as any)._post(
        "companies/exportxls"
      );
      window.open(response.path);
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }
  

  async loadBusiness() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.business = response.data;
  }


  async loadCompanies(page: number, sort: Record<string, string>) {
    this.currentSort = sort;
    const response: any = await (this.$root as any)._post("companies/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      ...this.filter,
      businessFilter: true,
    },);
    this.totalRows = response.totalRows;
    this.companies = response.data;
  }
}
